import { map } from "rxjs/operators";
import { GET, POST } from "../../../../module/services/fetch";

export const fetchPaginatedOU = (payload: any) => {
  const { body, sortBy } = payload;
  return POST(
    `admin/ou${
      sortBy && sortBy.length > 0
        ? `?sortField=${
            sortBy[0].id === "ouCode" ? "code" : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? "desc" : "asc"}`
        : ""
    }`,
    body
  ).pipe(map((response: any) => response));
};

export const fetchBRByOfficeRequest = (id: string | number) =>
  GET(`entitlements/businessRole?ou=${id}`).pipe(
    map((response: any) => response)
  );

export const fetchEntitlementsByOuRequest = (ou: string | number) =>
  GET(`entitlements?ou=${ou}`).pipe(map((response: any) => response));

export const createAdminBRRequest = (requestObj: FormData) =>
  POST(
    "admin/create/businessRole",
    requestObj,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));

export const modifyAdminBRRequest = (requestObj: FormData) =>
  POST(
    "admin/updateBusinessRole",
    requestObj,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));

export const fetchAdminDeleteBRRequest = (codeBR: any, attachments: FormData) =>
  POST(
    `admin/businessRole/${codeBR}/delete`,
    attachments,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));

export const getAdminBrEntitlements = (brId: string) =>
  GET(`admin/businessRoleEnt?brId=${brId}`).pipe(
    map((response: any) => response)
  );
